export const breakpointMobile = 512; // Mobile breakpoint for the IUI components
export const crimsonRed = '#ff0000'; // Color code for CrimsonLogic Red
export const productName = 'Automatic Broker Interface'; // Name of product